module.exports = __webpack_public_path__ + "src/assets/img/trank_open_color.09f40c10.svg";